<template>
    <div class="image-box" v-if="isShowImage">
      <div class="drapImage" :id="'drapImageId_'+index">
        <div class="apply-file-title" :class="{'successful':this.dataFile.files_path}">
          <span class="info_icon" v-show="!this.dataFile.files_path"></span>
          <label>{{this.index+1}}. {{this.dataFile.name}}</label>

          <div v-if="this.dataFile.files_path">
            <span class="successful_icon"></span>
            <span class="delete" @click="removeImage()" v-if="dataFile.status!=1"></span>
          </div>
          <div v-else>
            <span  class="upload upload-pos" >{{$t('upload')}}</span>
            <input type="file"  class="upload upload-hidden" @change="tirggerFile($event)"  >
          </div>
        </div>
      </div>
      <p class="error-tip" v-if="isSubmit&&!this.dataFile.files_path">{{$t('errorDocument')}}</p>
    </div>
</template>
<script>
  export default {
    name: 'File',
    data () {
      return {
        isShowImage: true
      }
    },
    mounted() {
      //拖动上传插件
      var dragDrop = document.getElementById('drapImageId_'+this.index);

      //拖拽上传文件
      dragDrop.addEventListener("dragover", function(e) {
        e.stopPropagation();
        //必须阻止默认事件
        e.preventDefault();
        $(this).addClass("upload_drag_hover");
      }, false);

      dragDrop.addEventListener("dragleave", function(e) {
        e.stopPropagation();
        e.preventDefault();
        $(this).removeClass("upload_drag_hover");
      }, false);

      let self = this;
      dragDrop.addEventListener("drop", function(e) {
        e.stopPropagation();
        e.preventDefault();
        //取消鼠标经过样式
        $(this).removeClass("upload_drag_hover");
        //获取文件列表对象和文件相对路径
        var files = e.target.files || e.dataTransfer.files;
        console.log(files)
        //处理数据
        if(files && files[0]) {
          if(files.length>1) {
            alert('Upload only one!');
          }else {
            self.isShowImage = false;
            if (files[0].type != "image/png" && files[0].type != "application/pdf" && files[0].type != "image/jpeg" && files[0].type != "image/tiff") {
              alert(self.$t('uploadFile'));
            } else {
              self.dataFile.files_path = files[0];
              self.$emit("changeImage", {
                file: self.dataFile,
                index: self.index
              });
            }
            self.isShowImage = true;
          }
        }
      }, false);
    },
    methods:{
      //删除图片
      removeImage(){
        this.isShowImage = false;
        this.dataFile.files_path = ''; // 看file文件对象
        this.$emit("changeImage", {
          file:this.dataFile,
          index:this.index
        });
        this.isShowImage = true;
      },
      //上传图片
      tirggerFile : function (e) {
        let files = e.target.files;
        if(files && files[0]) {
          this.isShowImage = false;
          if(files[0].type!="image/png"&&files[0].type!="application/pdf"&&files[0].type!="image/jpeg"&&files[0].type!="image/tiff"){
            alert(this.$t('uploadFile'))
          }else{
            this.dataFile.files_path = files[0];
            this.$emit("changeImage", {
              file:this.dataFile,
              index:this.index
            });
          }
          this.isShowImage = true;
        }
      },
    },
    props:['dataFile','index','isSubmit']
  }
</script>

<style>

/*  @import url("../../assets/css/common.css");*/
  .drapImage{
    border:1px solid #fff;
  }
  .upload_drag_hover{
    border-color:red;
  }
</style>



// WEBPACK FOOTER //
// src/components/default/File.vue